import { Injectable } from '@angular/core';

import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseService {
  protected constructor(
    protected baseRoute: string,
    protected httpService: HttpService,
  ) {}

  protected get apiUrl() {
    return this.baseRoute;
  }
}
